import { useNavigate } from "react-router-dom";

/**
 * Button that routes user to Data Requests page
 */

export default function DataRequestsButton() {
  const navigate = useNavigate();
  const handleNavigate = (fileName) => {
    navigate("/datarequests");
  };
  return (
    <button className="plain-button" onClick={() => handleNavigate()}>
      Data Requests
    </button>
  );
}


